import { Mutex } from 'await-semaphore';
import { AuthServiceV4 } from './AuthServiceV4';
import { getLoginUrl } from './AuthProxyUrlBuilder';
export class AuthServiceProviderV4 {
    constructor(authServiceOptions, sharedState, localeService, logger) {
        this.authServiceOptions = authServiceOptions;
        this.sharedState = sharedState;
        this.localeService = localeService;
        this.logger = logger;
        this.registeredAuthServices = {};
    }
    /**
     * Creates a new AuthService instance or returns an existing instance for an already registered fag.
     * @param fag FeatureAppGroup to register for
     */
    register(fag) {
        if (!this.authServiceOptions.fagScopeMappings.get(fag)) {
            throw new Error(`Unknown feature app group "${fag}". Please check authService configuration.`);
        }
        if (this.registeredAuthServices[fag]) {
            return this.registeredAuthServices[fag];
        }
        let sharedAuthServiceState = this.sharedState.authServiceState.get(fag);
        if (!sharedAuthServiceState) {
            sharedAuthServiceState = { mutex: new Mutex() };
            this.sharedState.authServiceState.set(fag, sharedAuthServiceState);
        }
        if (!sharedAuthServiceState.userInfoMutex) {
            sharedAuthServiceState = Object.assign(Object.assign({}, sharedAuthServiceState), { userInfoMutex: new Mutex() });
            this.sharedState.authServiceState.set(fag, sharedAuthServiceState);
        }
        const service = new AuthServiceV4(fag, this.sharedState.eventEmitter, this.authServiceOptions, this.loginAll.bind(this), sharedAuthServiceState, this.logger);
        this.registeredAuthServices[fag] = service;
        return service;
    }
    loginAll(prompt, redirectUrl) {
        const registeredFags = Array.from(this.sharedState.authServiceState.keys());
        const { language, countryCode } = this.localeService;
        const loginUrl = getLoginUrl(this.authServiceOptions, registeredFags, `${language}-${countryCode}`, prompt, redirectUrl);
        window.location.assign(loginUrl);
    }
}
//# sourceMappingURL=AuthServiceProviderV4.js.map